/*
 * consegna-prevista.js - DATA DI CONSEGNA PREVISTA NELL'ORDINE (25-09-2026).
 *
 * L'app Essential Estimated mostra sulla scheda prodotto la linea del tempo
 * (Ordinato / In lavorazione / Consegnato) ma non scrive niente nel
 * carrello. Qui, nel momento in cui il cliente preme "Aggiungi al carrello"
 * (o il pagamento rapido), si mette nel modulo una voce della riga con le
 * stesse date dell'app. La voce passa nel carrello, nel checkout, nell'email
 * di conferma e nell'ordine in admin.
 *
 * Stessa cosa fatta su DE (voce "Voraussichtliche Zustellung") e su UK
 * ("Estimated between"). Qui le date NON si leggono dal testo del widget ma
 * dai dati dell'app (widgetData.deliveryFromDate / deliveryToDate): sono le
 * stesse date che l'app scrive a schermo, ma non dipendono dalla lingua,
 * quindi lo stesso codice vale per /it e per /fr.
 *
 * Nome della voce secondo la lingua della pagina:
 *   it -> "Consegna prevista"    fr -> "Livraison prévue"
 * Formato: 29/09/2026 - 01/10/2026.
 *
 * Nessuna voce quando il blocco dell'app non si vede (prevendita, esaurito)
 * o quando l'app non ha ancora calcolato le date: meglio niente che una
 * data sbagliata.
 *
 * File a parte, caricato da layout/theme.liquid, per non toccare custom.js.
 */
(function () {
  'use strict';

  var ETICHETTE = {
    it: 'Consegna prevista',
    fr: 'Livraison prévue',
    en: 'Estimated delivery',
    de: 'Voraussichtliche Zustellung'
  };

  function lingua() {
    var l = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'it';
    return String(l).slice(0, 2).toLowerCase();
  }

  function etichetta() {
    return ETICHETTE[lingua()] || ETICHETTE.it;
  }

  function dueCifre(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function formato(d) {
    return dueCifre(d.getDate()) + '/' + dueCifre(d.getMonth() + 1) + '/' + d.getFullYear();
  }

  function dataApp(zona) {
    var widget = zona.querySelector('delivery-preview-widget');
    if (!widget) { return ''; }
    if (widget.getClientRects().length === 0) { return ''; } // blocco nascosto

    var dati = null;
    try { dati = widget.widget && widget.widget.widgetData; } catch (e) { dati = null; }
    if (!dati || !dati.deliveryFromDate || !dati.deliveryToDate) { return ''; }

    var da = new Date(dati.deliveryFromDate);
    var a = new Date(dati.deliveryToDate);
    if (isNaN(da.getTime()) || isNaN(a.getTime())) { return ''; }

    return formato(da) === formato(a) ? formato(da) : formato(da) + ' - ' + formato(a);
  }

  function mettiData(form) {
    if (!form || form.tagName !== 'FORM' || !/\/cart\/add/.test(form.getAttribute('action') || '')) { return; }

    var zona = form.closest('quick-buy-modal, .shopify-section') || document;
    var valore = dataApp(zona);
    var campo = form.querySelector('input[data-dpc-consegna]');

    if (!valore) {
      if (campo) { campo.remove(); }
      return;
    }

    if (!campo) {
      campo = document.createElement('input');
      campo.type = 'hidden';
      campo.setAttribute('data-dpc-consegna', '');
      form.appendChild(campo);
    }
    campo.name = 'properties[' + etichetta() + ']';
    campo.value = valore;
  }

  // in fase di cattura, prima del tema: la voce entra nei dati inviati
  document.addEventListener('submit', function (event) { mettiData(event.target); }, true);
  document.addEventListener('click', function (event) {
    var bottone = event.target.closest && event.target.closest('button, .shopify-payment-button');
    if (bottone) { mettiData(bottone.form || bottone.closest('form')); }
  }, true);
})();
